import { useEffect, useRef } from "react"

/** Simple utility hook for persisting the last value of something. Typically probably used with useState to be able to perform conditional logic based on what the state used to be versus what it is now. */
const usePrevious = <T,>(value: T) => {
	const ref = useRef<T | undefined>(undefined)
	useEffect(() => {
		ref.current = value
	})
	return ref.current
}

export default usePrevious
